import axios from 'axios';
import { SHOW_SNACK_BAR } from '../globalActions';

export const TEACHER_AVAILABILITY_LOADING = 'TEACHER_AVAILABILITY_LOADING';
export const TEACHER_AVAILABILITY_SUCCESS = 'TEACHER_AVAILABILITY_SUCCESS';
export const TEACHER_AVAILABILITY_ERROR = 'TEACHER_AVAILABILITY_ERROR';

export const SET_TEACHER_AVAILABILITY_LOADING = 'SET_TEACHER_AVAILABILITY_LOADING';
export const SET_TEACHER_AVAILABILITY_SUCCESS = 'SET_TEACHER_AVAILABILITY_SUCCESS';
export const SET_TEACHER_AVAILABILITY_ERROR = 'SET_TEACHER_AVAILABILITY_ERROR';

export const GET_TEACHER_BLOCKS_LOADING = 'GET_TEACHER_BLOCKS_LOADING';
export const GET_TEACHER_BLOCKS_SUCCESS = 'GET_TEACHER_BLOCKS_SUCCESS';
export const GET_TEACHER_BLOCKS_ERROR = 'GET_TEACHER_BLOCKS_ERROR';

export const GET_TEACHER_CREATED_BLOCKS_LOADING = 'GET_TEACHER_CREATED_BLOCKS_LOADING';
export const GET_TEACHER_CREATED_BLOCKS_SUCCESS = 'GET_TEACHER_CREATED_BLOCKS_SUCCESS';
export const GET_TEACHER_CREATED_BLOCKS_ERROR = 'GET_TEACHER_CREATED_BLOCKS_ERROR';

export const GET_CALENDAR_CREATED_BLOCKS_LOADING = 'GET_CALENDAR_CREATED_BLOCKS_LOADING';
export const GET_CALENDAR_CREATED_BLOCKS_SUCCESS = 'GET_CALENDAR_CREATED_BLOCKS_SUCCESS';
export const GET_CALENDAR_CREATED_BLOCKS_ERROR = 'GET_CALENDAR_CREATED_BLOCKS_ERROR';

export const CREATE_TEACHER_BLOCK_LOADING = 'CREATE_TEACHER_BLOCK_LOADING';
export const CREATE_TEACHER_BLOCK_SUCCESS = 'CREATE_TEACHER_BLOCK_SUCCESS';
export const CREATE_TEACHER_BLOCK_ERROR = 'CREATE_TEACHER_BLOCK_ERROR';

export const UPDATE_TEACHER_BLOCK_LOADING = 'UPDATE_TEACHER_BLOCK_LOADING';
export const UPDATE_TEACHER_BLOCK_SUCCESS = 'UPDATE_TEACHER_BLOCK_SUCCESS';
export const UPDATE_TEACHER_BLOCK_ERROR = 'UPDATE_TEACHER_BLOCK_ERROR';

export const DELETE_TEACHER_BLOCK_LOADING = 'DELETE_TEACHER_BLOCK_LOADING';
export const DELETE_TEACHER_BLOCK_SUCCESS = 'DELETE_TEACHER_BLOCK_SUCCESS';
export const DELETE_TEACHER_BLOCK_ERROR = 'DELETE_TEACHER_BLOCK_ERROR';

export function fetchTeacherAvailability() {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: TEACHER_AVAILABILITY_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/teacher/schedules`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: TEACHER_AVAILABILITY_SUCCESS,
          payload: response
        });
      })
      .catch(result => {
        dispatch({
          type: TEACHER_AVAILABILITY_ERROR,
          payload: result
        });
      });
  };
}

export function setTeacherAvailability(availability) {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: SET_TEACHER_AVAILABILITY_LOADING });

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/teacher/schedules`, availability, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: SET_TEACHER_AVAILABILITY_SUCCESS,
          payload: response.data.data
        });
        // TODO: not sure if this is the best thing to do but this architecture
        // feels limiting ...all I'm trying to do is update two objects here
        dispatch({
          type: 'REFRESH_USER_SUCCESS',
          payload: response.data.data
        });
        dispatch({ type: SHOW_SNACK_BAR });
      })
      .catch(result => {
        dispatch({
          type: SET_TEACHER_AVAILABILITY_ERROR,
          payload: result
        });
      });
  };
}

export function fetchTeacherBlocks() {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: GET_TEACHER_BLOCKS_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/teacher/blockedTimes`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: GET_TEACHER_BLOCKS_SUCCESS,
          payload: response
        });
      })
      .catch(result => {
        dispatch({
          type: GET_TEACHER_BLOCKS_ERROR,
          payload: result
        });
      });
  };
}

export function fetchTeacherCreatedBlocks() {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: GET_TEACHER_CREATED_BLOCKS_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/teacher/blockedTimes/user`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: GET_TEACHER_CREATED_BLOCKS_SUCCESS,
          payload: response
        });
      })
      .catch(result => {
        dispatch({
          type: GET_TEACHER_CREATED_BLOCKS_ERROR,
          payload: result
        });
      });
  };
}

export function fetchCalendarCreatedBlocks() {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: GET_CALENDAR_CREATED_BLOCKS_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/teacher/blockedTimes/calendar`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: GET_CALENDAR_CREATED_BLOCKS_SUCCESS,
          payload: response
        });
      })
      .catch(result => {
        dispatch({
          type: GET_CALENDAR_CREATED_BLOCKS_ERROR,
          payload: result
        });
      });
  };
}

export function createTeacherBlock(block) {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: CREATE_TEACHER_BLOCK_LOADING });

    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/teacher/blockedTimes`, block, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: CREATE_TEACHER_BLOCK_SUCCESS,
          payload: response
        });
        dispatch({ type: SHOW_SNACK_BAR });
      })
      .catch(result => {
        dispatch({
          type: CREATE_TEACHER_BLOCK_ERROR,
          payload: result
        });
      });
  };
}

export function updateTeacherBlock(blockId, block) {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: UPDATE_TEACHER_BLOCK_LOADING });

    axios
      .put(`${process.env.REACT_APP_BACKEND_URL}/teacher/blockedTimes/${blockId}`, block, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: UPDATE_TEACHER_BLOCK_SUCCESS,
          payload: response
        });
        dispatch({ type: SHOW_SNACK_BAR });
      })
      .catch(result => {
        dispatch({
          type: UPDATE_TEACHER_BLOCK_ERROR,
          payload: result
        });
      });
  };
}

export function deleteTeacherBlock(blockId) {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: DELETE_TEACHER_BLOCK_LOADING });

    axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/teacher/blockedTimes/${blockId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(() => {
        dispatch({
          type: DELETE_TEACHER_BLOCK_SUCCESS,
          payload: { id: blockId }
        });
        dispatch({ type: SHOW_SNACK_BAR });
      })
      .catch(result => {
        dispatch({
          type: DELETE_TEACHER_BLOCK_ERROR,
          payload: result
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/Teacher/availabilityActions.js